import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import { getCurrentUser } from "../../app/store/auth";
import { useLoadAllReviewNotesQuery, useAddReviewNotesMutation } from "../../app/store/reviewNotesApiSlice";
import { useSendEditReqFormLibraryMutation } from "../../app/store/formsApiSlice";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";

const NOTES_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px"
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  modalTitle: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  modalSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px"
  },
  tableWrap: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    overflow: "hidden"
  },
  table: {
    marginBottom: 0,
    minWidth: "820px"
  },
  tableHeadCell: {
    fontSize: "11px",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "#64748b",
    background: "#f8fafc",
    padding: "12px 16px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)"
  },
  tableCell: {
    padding: "16px",
    fontSize: "13px",
    color: "#334155",
    verticalAlign: "top",
    borderBottom: "1px solid rgba(241, 245, 249, 1)"
  },
  serialBadge: {
    width: "28px",
    height: "28px",
    borderRadius: "8px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "12px",
    fontWeight: 800
  },
  performerText: {
    fontWeight: 700,
    color: "#0f172a"
  },
  performerMeta: {
    fontSize: "11px",
    color: "#64748b",
    marginTop: "2px"
  },
  label: {
    fontSize: "13px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px",
    display: "block"
  },
  helpText: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.55,
    margin: "0 0 14px 0"
  },
  textarea: {
    borderRadius: "12px",
    border: "1px solid #d8dee8",
    padding: "12px 16px",
    fontSize: "14px",
    transition: "all 0.2s ease",
    minHeight: "150px",
    resize: "vertical",
    backgroundColor: "#ffffff"
  },
  countText: {
    marginTop: "8px",
    fontSize: "11px",
    color: "#64748b",
    textAlign: "right"
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px"
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    border: "none",
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
    transition: "all 0.2s ease"
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
    background: "#ffffff",
    color: "#475569",
    border: "1px solid rgba(226, 232, 240, 1)"
  },
  emptyState: {
    padding: "34px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px"
  }
};

const AddEditNotes = (props) => {
  const { noteShowHide, handleNoteShowHide, notesType,
    candidateObj, timeLogObj, selectedObj } = props;

  const [notes, setNotes] = useState("");

  const currentUser = getCurrentUser();
  const performerId = candidateObj?.performerid;

  const { data: notesData = [] } = useLoadAllReviewNotesQuery(
    { type: notesType, id: performerId },
    { skip: !performerId || notesType === "formEditReq" }
  );

  const [addReviewNotes, { isLoading: isAddingNotes, isSuccess: isAddNotesSuccess }] =
    useAddReviewNotesMutation();

  const [sendEditReqFormLibrary, { isLoading: isSendingEditReq, isSuccess: isEditReqSuccess }] =
    useSendEditReqFormLibraryMutation();

  const btnSaveProcess = isAddingNotes || isSendingEditReq;

  const allNotes = useMemo(() => {
    if (!notesData) return [];
    if (timeLogObj?.id > 0) {
      return notesData.filter((x) => x.ciid === timeLogObj.id);
    }
    return notesData;
  }, [notesData, timeLogObj]);

  const doSubmit = useCallback(async () => {
    if (notesType === "formEditReq") {
      const result = await getConfirmAlert("Warning", "Are you sure you want to send edit request for this form?", "warning");
      if (result.isConfirmed) {
        sendEditReqFormLibrary({ id: selectedObj?.id, notes });
      }
    } else {
      const frmData = new FormData();
      frmData.append("comment", notes);
      frmData.append("type", notesType);
      frmData.append("userId", currentUser?.id || 0);
      frmData.append("performerId", candidateObj?.performerid || 0);
      if (timeLogObj?.id > 0) {
        frmData.append("ciid", timeLogObj.id);
      }
      addReviewNotes(frmData);
    }
  }, [notesType, notes, selectedObj, candidateObj, timeLogObj, currentUser, addReviewNotes, sendEditReqFormLibrary]);

  useEffect(() => {
    if (isAddNotesSuccess) {
      getAlert("", "Saved Successfully", "success");
      setNotes("");
      handleNoteShowHide("save", "");
    }
  }, [isAddNotesSuccess, handleNoteShowHide]);

  useEffect(() => {
    if (isEditReqSuccess) {
      getAlert("", "Request Sent Successfully", "success");
      setNotes("");
      handleNoteShowHide("save", "");
    }
  }, [isEditReqSuccess, handleNoteShowHide]);

  return (
    <Modal
      show={noteShowHide}
      size="xl"
      centered
      onHide={() => handleNoteShowHide("", "")}
      dialogClassName="add-edit-notes-modal-dialog"
      contentClassName="add-edit-notes-modal-content"
    >
      <Modal.Header style={NOTES_STYLES.modalHeader}>
        <div style={NOTES_STYLES.headerContent}>
          <Modal.Title as="div" style={NOTES_STYLES.titleWrap}>
            <div style={NOTES_STYLES.headerIcon}>
              <i className={notesType === "formEditReq" ? "fa fa-pencil-square-o" : "fa fa-comments-o"} aria-hidden="true"></i>
            </div>
            <div>
              <div style={NOTES_STYLES.modalTitle}>{notesType === "formEditReq" ? "Form Edit Request" : "Review History"}</div>
              <div style={NOTES_STYLES.modalSubtitle}>
                {notesType === "formEditReq"
                  ? "Share what needs to be unlocked or corrected before sending the request."
                  : "Review previous notes, comments, and activity for this item."}
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={NOTES_STYLES.closeButton}
            onClick={() => handleNoteShowHide("", "")}
            aria-label="Close notes popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>
      <Modal.Body style={NOTES_STYLES.modalBody}>
        <style>{`
          .add-edit-notes-modal-dialog {
            max-width: 920px;
          }
          .add-edit-notes-modal-content {
            border-radius: ${NOTES_STYLES.modalContent.borderRadius};
            overflow: ${NOTES_STYLES.modalContent.overflow};
            border: ${NOTES_STYLES.modalContent.border};
            box-shadow: ${NOTES_STYLES.modalContent.boxShadow};
          }
          .notes-table tbody tr:hover { background-color: #fbfdff; }
          .notes-textarea:focus { 
            border-color: #3b82f6 !important; 
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important; 
          }
          .notes-send-button:disabled {
            cursor: not-allowed;
            opacity: 0.58;
            box-shadow: none !important;
          }
        `}</style>
        <div style={NOTES_STYLES.helperCard}>
          <div style={NOTES_STYLES.helperTitle}>
            {notesType === "formEditReq" ? "Request guidance" : "Review guidance"}
          </div>
          <p style={NOTES_STYLES.helperText}>
            {notesType === "formEditReq"
              ? "Describe the exact form section or field that needs to be reopened, corrected, or reviewed."
              : "Use this history to understand prior reviewer comments, timestamps, and ownership details."}
          </p>
        </div>

        <div style={NOTES_STYLES.sectionCard}>
          {notesType !== "formEditReq" && (
            <div>
              <div style={NOTES_STYLES.tableWrap}>
                <div className="table-responsive" style={{ maxHeight: "420px" }}>
                  <table className="table align-items-center table-hover notes-table" style={NOTES_STYLES.table}>
                    <thead>
                      <tr>
                        <th style={NOTES_STYLES.tableHeadCell}>#</th>
                        <th style={NOTES_STYLES.tableHeadCell}>Date & Time</th>
                        <th style={NOTES_STYLES.tableHeadCell}>Review</th>
                        <th style={NOTES_STYLES.tableHeadCell}>Added By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allNotes.length > 0 ? allNotes.map((item, key) => (
                        <tr key={key}>
                          <td style={NOTES_STYLES.tableCell}>
                            <span style={NOTES_STYLES.serialBadge}>{key + 1}</span>
                          </td>
                          <td style={NOTES_STYLES.tableCell}>
                            <div className="font-weight-bold">
                              <Moment format="MMM Do YYYY">
                                {item.dateTime}
                              </Moment>
                            </div>
                            <div className="small text-muted">
                              <Moment format="h:mm a">
                                {item.dateTime}
                              </Moment>
                            </div>
                          </td>
                          <td style={NOTES_STYLES.tableCell}>
                            <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.5 }}>{item.comments}</div>
                          </td>
                          <td style={NOTES_STYLES.tableCell}>
                            <div style={NOTES_STYLES.performerText}>{item.performer}</div>
                            <div style={NOTES_STYLES.performerMeta}>
                              <div>{item.email}</div>
                              <div className="mt-1">
                                <span className="badge badge-pill badge-secondary">{item.role}</span>
                                {item.department && <span className="ml-1 text-muted">| {item.department}</span>}
                              </div>
                              {item.partner && <div className="text-primary mt-1 font-weight-bold">{item.partner}</div>}
                            </div>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="4" style={NOTES_STYLES.emptyState}>
                            <i className="fa fa-folder-open-o fa-3x mb-3 d-block opacity-2"></i>
                            No notes found for this category.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          {notesType === "formEditReq" && (
            <div>
              <label htmlFor="notes" style={NOTES_STYLES.label}>Please provide details for the edit request</label>
              <p style={NOTES_STYLES.helpText}>
                Include the specific field or section that needs changes and any context the reviewer should know.
              </p>
              <textarea
                className="form-control notes-textarea"
                style={NOTES_STYLES.textarea}
                id="notes"
                name="notes"
                placeholder="Type your notes here..."
                value={notes}
                onChange={({ currentTarget }) => setNotes(currentTarget.value)}
              ></textarea>
              <div style={NOTES_STYLES.countText}>{notes.trim().length} characters</div>
            </div>
          )}
        </div>


      </Modal.Body>
      <Modal.Footer style={NOTES_STYLES.modalFooter}>
        {notesType === "formEditReq" && (
          <div style={NOTES_STYLES.footerActions}>
            <button
              className="btn"
              style={NOTES_STYLES.cancelButton}
              disabled={btnSaveProcess}
              onClick={() => handleNoteShowHide("", "")}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Cancel
            </button>
            <button
              className="btn notes-send-button"
              style={NOTES_STYLES.sendButton}
              disabled={!notes.trim() || btnSaveProcess}
              onClick={doSubmit}
            >
              {btnSaveProcess ? (
                <><i className="fa fa-circle-o-notch fa-spin mr-1"></i> Sending...</>
              ) : (
                <><i className="fa fa-paper-plane-o" aria-hidden="true"></i> Send Request</>
              )}
            </button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default AddEditNotes;

